import environment from "src/utils/environment";
const { isDev, isBrowser } = environment;
const remote = window.require("@electron/remote");

export default function updateWindowSize() {
  if (isBrowser) return;
  const isProduction = !isDev;

  const browserWindow = remote.getCurrentWindow();

  if (isDev) {
    browserWindow.setResizable(true);
    browserWindow.setMinimumSize(
      remote.getGlobal("wizardWidth"),
      remote.getGlobal("wizardHeight")
    );
    return;
  }

  const shouldUpdate = browserWindow.isResizable();

  if (isProduction && shouldUpdate) {
    browserWindow.setMinimumSize(
      remote.getGlobal("wizardWidth"),
      remote.getGlobal("wizardHeight")
    );
    browserWindow.setSize(
      remote.getGlobal("wizardWidth"),
      remote.getGlobal("wizardHeight"),
      true
    );
    browserWindow.setResizable(false);
  }
}
